import { defineComponent, ref } from 'vue'
import { Vue3Marquee as Marquee } from 'vue3-marquee'

export default defineComponent({
    setup() {
        const paused = ref(false)

        return {
            paused
        }
    },
    components: {
        Marquee
    }
})